import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input, Button } from "reactstrap";
function AssetsgalleryImges(props){
  
    const handleReplaceImages = (img) => {
      props.setSelectedImages(img)
    }
  
  
    return(
        <>
           <div className='d-flex justify-content-end mb-2' >
              <Button 
              className='mr-2'
              onClick={() => props.handleSubmitFile()}>
                Replace
              </Button>
              {/* <Button onClick={() => handleUpdateFiles()}>
                Add Images
              </Button> */}
            </div>
          <Row>
           
            {props.galleryImg && props.galleryImg.map((asset) => (
              <Col sm={4} md={3} key={asset.fileId}>
                <Card 
                  style={{
                    border:
                      props.selectedImages?props.selectedImages.fileId === asset.fileId:''
                        ? "2px solid #007bff"
                        : "1px solid #ddd",
                  }}
                >
                  <div onClick={() => handleReplaceImages(asset)}>
                    <img
                      src={asset.filePath}
                      alt="not found"
                      width="100%"
                      height="100%"
                    />
  
                    <p className="text-center mt-2" title={asset.fileName} style={{ fontSize: "13px" }}>
                      {asset.fileName.length > 30
                        ? `${asset.fileName.substring(0, 30)}...`
                        : asset.fileName}
                    </p>
                  </div>
  
                  <div className="text-center mt-2">
                    <input
                      type="checkbox"
                      checked={props.selectedImages?props.selectedImages.fileId === asset.fileId:''}
                      // checked={props.selectedImages.includes(asset.fileId)}
                      onChange={(e) => {
                        e.stopPropagation()
                        handleReplaceImages(asset)
                      }}
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
  
      </>
    )
}
export default AssetsgalleryImges